// Angular
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

// Class/Data/Interface/Extra
import { PasswordChange } from 'src/app/shared/classes';

// Services
import { MessagesService } from 'src/app/services/message/messages.service';
import { LoginService } from 'src/app/services/login/login.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.less']
})
export class ResetPasswordComponent implements OnInit {
  public year = new Date().getFullYear();
  public resetPasswordForm;
  private resetPasswordToken = '';

  constructor(private fb: FormBuilder, private login: LoginService, private msg: MessagesService, private actRoute: ActivatedRoute,
    private router: Router, private location: Location, private load: NgxSpinnerService) { }

  ngOnInit() {
    this.getResetToken();
    this.initForm();
  }

  // get token
  private getResetToken() {
    this.actRoute.params.subscribe(param => {
      this.resetPasswordToken = param.token;
    });
  }

  // inits forgot password form
  private initForm() {
    this.resetPasswordForm = this.fb.group({
      user_id: ['', [Validators.required]],
      password: this.fb.group({
        password1: ['', [Validators.required]],
        password2: ['', [Validators.required]],
      })
    });
  }

  // changes password
  public changePassword() {
    this.load.show();

    const user_id = this.resetPasswordForm.value.user_id;
    const password = this.resetPasswordForm.value.password.password1;
    const password2 = this.resetPasswordForm.value.password.password2;
    const token = this.resetPasswordToken;

    if (password !== password2) {
      this.msg.warn('Password is not the same');
      return;
    } if (!token || token === '') {
      this.msg.warn('Token missing - enable to change password');
    }

    const changePassObj = new PasswordChange(user_id, password, password2, token);

    this.login.resetPassword(changePassObj)
      .then(res => this.processSuccess(res))
      .catch(error => this.processError(error));
  }

  // process any success
  private processSuccess(res) {
    this.load.hide();

    this.msg.success(res);
    this.msg.info('Redirecting you to login page');

    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 2000);
  }

  // process any error
  private processError(error) {
    this.load.hide();

    this.msg.error(error);
  }

  // goes back
  public goBack() {
    this.location.back();
  }
}
